<div class="score-div">
  <div class="title-div">
    <p class="match-title">Your Overall Match</p>
    <img 
      src='/assets/icons/summary/info-circle.svg' 
      alt="info"
      [matTooltip]="matchScoreTooltip"
      matTooltipPosition="after"
      (mouseenter)="onInfoHover()"
      style="cursor: pointer;"
    />
  </div>
  <div class="match-score-div">
    <img 
      [src]="'/assets/icons/summary/' + matchScore + '_circle.svg'" 
      alt="match-score"
      class="match-score-circle" 
    />
    <p class="score-text">{{ displayScore }}</p>
  </div>
</div>